export default __webpack_public_path__ + "img/apply_text_2-7dd85f73.png";